import Axios from "./Axios";

export default class CategoryService extends Axios {

  getPDV(pdv) {
    return this.axios.get(`/pdv/${pdv}`)
  }

  getAccessPoint(accessPoint) {
    return this.axios.get(`/access-point/${accessPoint}`)
  }

  getCategories() {
    return this.axios.post(`/categories/access-point/${JSON.parse(localStorage.getItem("accessPoint")).id}`);
  }
}
